import { TFunction } from "i18next";
import { z } from "zod";

// MED-1253: common duration presets offered in the "Grant free access" modal.
// Kept as strings for the <Select> control, converted to a number on submit.
export const GRANT_FREE_ACCESS_DURATIONS = ["1", "3", "6", "12"] as const;

export const grantFreeAccessSchema = (t: TFunction) =>
  z.object({
    durationMonths: z.enum(GRANT_FREE_ACCESS_DURATIONS, {
      error: () => ({ message: t("validation.required") }),
    }),
    reason: z
      .string()
      .trim()
      .min(1, t("validation.required"))
      .max(255, t("admin.doctors.grant.form.reasonTooLong")),
  });

export type GrantFreeAccessFormData = z.infer<
  ReturnType<typeof grantFreeAccessSchema>
>;
